import React, { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { AuthenticationLayout } from "../../Components/Layouts/AuthenticationLayout";
import Logo from '../../Assets/images/logo/connectcaremintgreen.png';
import { BaseCard } from '../../Components/Cards/BaseCard';
import { PrimaryButton } from '../../Components/Buttons/PrimaryButton';
import { useNavigate } from 'react-router-dom';
import { useBoundStore } from '../../Store/store';
import toast from 'react-hot-toast';

const PendingApproval = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const logOut = useBoundStore(state => state.logOut);
    const getMe = useBoundStore(state => state.getMe);
    const [checkTimestamps, setCheckTimestamps] = useState([]);

    const handleLogout = () => {
        logOut();
        navigate('/login');
    };

    const handleRecheckAccess = async () => {
        const now = Date.now();
        const recentChecks = checkTimestamps.filter(ts => now - ts < 60000);
        if (recentChecks.length >= 2) {
            toast.error(t('auth.pending_rate_limit'));
            return;
        }
        setCheckTimestamps([...recentChecks, now]);
        await getMe();
        const updatedUser = useBoundStore.getState().user;
        if (updatedUser && updatedUser.approved_at) {
            if (updatedUser.type === 'freelancer') {
                navigate('/freelancer');
            } else {
                navigate('/');
            }
        } else {
            toast.error(t('auth.pending_not_approved'));
        }
    };

    return (
        <div className={'flex flex-col justify-center min-h-screen w-full h-full'}>
            <div className={'p-3 text-center'}>
                <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-16 mx-auto'}/>
            </div>
            <BaseCard>
                <h1 className={'text-2xl font-bold text-center mb-4'}>{t('auth.pending_approval.title')}</h1>
                <p className={'text-center text-md text-gray-700 mb-2'}>
                    {t('auth.pending_approval.message')}
                </p>
                <p className={'text-center text-sm text-gray-500 mb-4'}>
                    {t('auth.pending_approval.sub_message')}
                </p>
                <div className="flex justify-center mt-4 gap-2">
                    <PrimaryButton onClick={handleLogout}>
                        {t('general.actions.logout')}
                    </PrimaryButton>
                    <PrimaryButton outlined onClick={handleRecheckAccess}>
                        {t('auth.pending_approval.recheck_access')}
                    </PrimaryButton>
                </div>
            </BaseCard>
        </div>
    );
};

export default PendingApproval;

